var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"from-center"}},[_c('div',{staticClass:"center-modal",style:({ maxWidth: _vm.width + 'px' })},[_c('i',{staticClass:"close-button xi-close",on:{"click":function($event){return _vm.$emit('close')}}}),_c('div',{staticClass:"side-modal-wrap"},[_c('transition',{attrs:{"name":"fade"}},[_vm._t("default")],2)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }